import { Expose } from "../serialization/class-transformer/decorators";

@Expose()
export class ExposeAllObjects extends Object { }
